import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetObjectLogs } from "../../../store/ObjectLogAction";
import ObjectLogs from "../../misc/ObjectLogs";
import { CoreObjectLogs } from "../../../models/CoreObjectLogs";
import * as LogTypes from '../../../util/FlowSyncLoggerTypes';
import { useTranslation } from "react-i18next";
import { RequestState } from "../../../models/RequestState";
import { RootState } from "../../../store/store";



const ScheduleSyncUserObjectLogs = () => {
    const { t } = useTranslation(['scheduleSync']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const objectLogs = useSelector<RootState, RequestState<CoreObjectLogs[]>>(state => state.objectLog.objectLogs);


    useEffect(() => {
        if (userId) {
            GetObjectLogs({ objectId: userId, objectSource: LogTypes.Flowsync.SourceName, objectType: LogTypes.Flowsync.ScheduleUser })(dispatch);
        }
    }, [dispatch, userId]);

    return (<>
        <ObjectLogs
            objectLogs={objectLogs}
            noResMsg={t('noResult.userObjectLogs')}
        />
    </>);
}

export default ScheduleSyncUserObjectLogs;
